import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-08852abe")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DefaultIcon = _resolveComponent("DefaultIcon")

  return _withDirectives((_openBlock(), _createBlock("span", {
    class: ['text-gray-50  dark:text-gray-700', + _ctx.itemMy + ' ' + _ctx.itemWidth + ' ' + _ctx.cssClass]
  }, [
    (_ctx.itemIconPre.length > 0)
      ? (_openBlock(), _createBlock(_component_DefaultIcon, {
          key: 0,
          icon: _ctx.itemIconPre,
          class: "pr-1"
        }, null, 8, ["icon"]))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_ctx.itemText) + " ", 1),
    (_ctx.itemIconAfter.length > 0)
      ? (_openBlock(), _createBlock(_component_DefaultIcon, {
          key: 1,
          icon: _ctx.itemIconAfter,
          class: "pl-1"
        }, null, 8, ["icon"]))
      : _createCommentVNode("", true)
  ], 2)), [
    [_vShow, _ctx.showItem]
  ])
})